// Vendor imports
const { connect } = require('react-redux')
// Client V1 imports
const analytics = require('client/lib/analytics')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const articleModelActions = require('client-v2/common/models/article/actions')
const articleModelConnect = require('client-v2/common/models/article/connect')
const deferDispatch = require('client-v2/common/state/dispatch')
// Container imports
const articleProfileModalActions = require('../state/modal-actions')
const {
  getSlide,
  makeSlideRelatedSelectors
} = require('../state/selectors')
const ArticleProfileRelated = require('./related-dumb')

function mapStateToProps() {
  const {
    getSlideRelatedDenormalizedItems
  } = makeSlideRelatedSelectors()
  return function (state, props) {
    return {
      items: getSlideRelatedDenormalizedItems(state, props)
    }
  }
}

function mapDispatchToProps(dispatch, props) {
  const { dispatchAction } = deferDispatch(dispatch)
  return Object.assign({}, articleModelConnect.mapDispatchToProps(dispatch), {
    onCollectionsClick: dispatchAction(showRelatedArticleProfileModal),
    onContentClick: dispatchAction(navigateToArticleContent)
  })

  function showRelatedArticleProfileModal({ article, pageContext }) {
    const urlId = article && article['url_id']
    const pageContextWithReferrerPageSection = Object.assign({
      referrerPageSection: 'related-articles'
    }, pageContext)
    return function (dispatch, getState) {
      const slide = getSlide(getState(), props)
      const { relatedStream: { items, meta } } = slide
      dispatch(articleProfileModalActions.show({
        initialIndex: items.findIndex(item => item.id === urlId),
        items,
        meta,
        pageContext: pageContextWithReferrerPageSection
      }))
    }
  }

  function navigateToArticleContent({ article, pageContext }) {
    return function (dispatch) {
      // Set referrer to the modal, current context to the related item
      analytics.withTemporaryPageContext(pageContext, () => {
        dispatch(articleModelActions.navigateToArticleContent({ article }))
      })
    }
  }
}

// Exports

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    ArticleProfileRelated
  )
)

module.exports = SmartComponent
